import styled, { css } from 'styled-components';

export const StyledWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const StyledPageWrapper = styled.div<{ visible: boolean }>(
  ({ theme, visible }) => css`
    display: flex;
    opacity: ${visible ? '1' : '0'};
    pointer-events: ${visible ? 'auto' : 'none'};
    visibility: ${visible ? 'visible' : 'hidden'};
    transition: opacity ${theme.Transition.Timing.Out};
    flex: 1;
    position: absolute;
    width: 120%;
    left: -10%;
    top: -100px;
    align-items: center;
    justify-content: center;
  `
);
